var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelopGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 0H12.75C13.9905 0 15 1.0095 15 2.25V9.75C15 10.9905 13.9905 12 12.75 12H2.25C1.0095 12 0 10.9905 0 9.75V2.25C0 1.0095 1.0095 0 2.25 0ZM7.87125 4.851L12.75 1.5H2.25L7.12875 4.851C7.359 4.98225 7.641 4.98225 7.87125 4.851Z",
    fill: "#AEBCD0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopGray);
export default __webpack_public_path__ + "static/media/envelopGray.4b3e6ed3208fd7ef27921ac6ba3c7cc3.svg";
export { ForwardRef as ReactComponent };